import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { jt, t } from 'ttag'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import Modal from 'react-bootstrap/es/Modal'
import { Link } from 'react-router-dom'
import ReactImageFallback from 'react-image-fallback'

import college from '@h2/assets/svg/icons/college.svg'
import like from '@h2/assets/svg/icons/thumbsUpActive.svg'
import likeInactive from '@h2/assets/svg/icons/thumbsUpInactive.svg'
import dislike from '@h2/assets/svg/icons/thumbsDownActive.svg'
import dislikeInactive from '@h2/assets/svg/icons/thumbsDownInactive.svg'
import compatibility0 from '@h2/assets/svg/icons/compatibility0.svg'
import compatibility1 from '@h2/assets/svg/icons/compatibility1.svg'
import compatibility2 from '@h2/assets/svg/icons/compatibility2.svg'
import compatibility3 from '@h2/assets/svg/icons/compatibility3.svg'
import compatibility4 from '@h2/assets/svg/icons/compatibility4.svg'
import compatibility5 from '@h2/assets/svg/icons/compatibility5.svg'

import TuitionSection from './sections/TuitionSection'
import AdmissionSection from './sections/AdmissionSection'
import FinancialAidSection from './sections/FinancialAidSection'
import EnrollmentSection from './sections/EnrollmentSection'
import StudentBodySection from './sections/StudentBodySection'

import {
  createPlan,
  loadCollege,
  rateCollege,
  toggleCollegeFlag
} from '../../actions/colleges'
import { openSigninDialog } from '../../actions/signinOrRegisterDialog'
import PopupJournal from '../../components/journal/PopupJournal'
import { toggleModal } from '../../actions/modals'
import Share from '../../components/social/Share'
import LoadingIndicator from '../../components/LoadingIndicator'
import withOpenMaps from '../../components/withOpenMaps'
import { monthNames } from '../../actions'
import { useInitDispatch, useTitleChange } from '../../util/hooks'

class MajorListing extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalShown: false
    }
  }

  render() {
    const profs = this.props.majors
      .sort((a, b) => {
        return b.undergradCompletions - a.undergradCompletions
      })
      .filter(a => !a.rollUp && a.title && a.totalCompletions > 0)
    const profs2 = profs.length > 25 ? profs.slice(0, 25) : profs

    return (
      <div className="section">
        <h3>
          <span>{t`Majors Offered `}</span>
        </h3>
        <ul>
          {profs2.map(m => (
            <li>
              <Link to={m.url}>{m.title}</Link>
            </li>
          ))}
          <a
            href="javascript:void(0)"
            className="pull-right btn-h2more"
            onClick={() => this.setState({ ...this.state, modalShown: true })}>
            {t`View All`}
          </a>
        </ul>
        <Modal
          bsSize="large"
          show={this.state.modalShown}
          onHide={() => this.setState({ ...this.state, modalShown: false })}>
          <Modal.Header closeButton>
            <h2>{t`Majors Offered`}</h2>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '80vh', overflow: 'scroll' }}>
            <table className="tbl table">
              <thead>
                <tr>
                  <th>{t`Program Title`}</th>
                  <th>{t`Undergraduate Completers`}</th>
                  <th>{t`Graduate Completers`}</th>
                </tr>
              </thead>
              <tbody>
                {profs.map((m, idx) => (
                  <tr className={idx % 2 == 0 ? 'even' : 'odd'}>
                    <td>
                      <Link to={m.url}>{m.title}</Link>
                    </td>
                    <td>{m.undergradCompletions > 0 ? m.undergradCompletions : '-'}</td>
                    <td>{m.gradCompletions > 0 ? m.gradCompletions : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

const MyMapComponent = withOpenMaps(
  ({ profile, MapContainer, Marker, Popup, TileLayer }) => {
    if (!profile.latitude || !profile.longitude) {
      return null
    }

    const position = [parseFloat(profile.latitude), parseFloat(profile.longitude)]
    const zoom = 14

    return (
      <div>
        <MapContainer center={position} zoom={zoom}>
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position}>
            <Popup>
              <div style={{ display: 'inline-block' }}>
                <b>{profile.name}</b>
                <br />
                {profile.address} <br />
                {profile.city}, {profile.state} {profile.zipCode}
              </div>
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    )
  }
)
const CollegeProfile = ({
  selected,
  onRateCollege,
  onCreatePlan,
  modals,
  onToggleModal,
  match
}) => {
  const [profile, setProfile] = useState(selected)
  const fallbackCollegeImage = college
  const collegeImageUrl = profile?.domain
    ? `/images/institution/${profile.id}/logo.png`
    : fallbackCollegeImage
  const aboutSection = () => {
    return (
      <div className="section" id="collegeinfo">
        <h3>
          <span>{t`Information`}</span>
        </h3>
        <div className="row">
          <div
            itemScope=""
            itemType="http://data-vocabulary.org/Organization"
            className="col-xs-6">
            <p>
              <span className="summary-desc-name">{t`Name:`}</span>{' '}
              <span className="name" itemProp="name">
                {profile.name}
              </span>
            </p>
            <p itemProp="address" itemType="http://data-vocabulary.org/Address">
              <span className="summary-desc-name">{t`Address:`}</span>{' '}
              <div style={{ display: 'inline-block' }}>
                <span className="address" itemProp="street-address">
                  {profile.address}
                </span>{' '}
                <br />
                <span className="city" itemProp="locality">
                  {profile.city}
                </span>
                ,{' '}
                <span className="state" itemProp="region">
                  {profile.state}
                </span>{' '}
                <span className="zipCode" itemProp="postal-code">
                  {profile.zipCode}
                </span>
              </div>
            </p>
            <p>
              <span className="summary-desc-name">{t`Website:`}</span>{' '}
              <span className="url">
                <a
                  href={profile.urlLink}
                  target="_self"
                  className="urlLink"
                  itemProp="url"
                  rel="nofollow">
                  {profile.urlLink}
                </a>
              </span>
            </p>
            <p>
              <span className="summary-desc-name">{t`Phone:`}</span>{' '}
              <span className="phone" itemProp="tel">
                {profile.phone}
              </span>
            </p>
            <p>
              <span className="summary-desc-name">{t`Size: `}</span>{' '}
              <span className="size">{profile.size}</span>
            </p>
            <p>
              <span className="summary-desc-name">{t`Setting:`}</span>{' '}
              <span className="setting">{profile.setting}</span>
            </p>
            <p>
              <span className="summary-desc-name">{t`Sector:`}</span>{' '}
              <span className="sector">{profile.sector}</span>
            </p>
            <p>
              <span className="summary-desc-name">{t`Highest Offering:`} </span>{' '}
              <span className="degree">{profile.degree}</span>
            </p>
          </div>
          <div className="col-xs-6">
            <div className="with-dotted-border">
              <MyMapComponent profile={profile} />
            </div>
          </div>
          {profile.additionalLinks.map((lnk, idx) => (
            <div
              className="col-xs-12"
              style={{ paddingTop: '25px' }}
              key={`additional-key-${idx}`}>
              <a className="pull-right btn-h2more" href={lnk.link}>
                {lnk.title}
              </a>
            </div>
          ))}
        </div>
      </div>
    )
  }
  const youAndOcc = () => {
    const per = profile.personalization || {}
    const rating = per && per.hasOwnProperty('rating') ? per.rating : null
    const comp = () => {
      if (per && per.hasOwnProperty('compatibility')) {
        const key = Math.max(0, per.compatibility.score || 0)

        switch (key) {
          case 1:
            return compatibility1
          case 2:
            return compatibility2
          case 3:
            return compatibility3
          case 4:
            return compatibility4
          case 5:
            return compatibility5

          default:
            return compatibility0
        }
      }

      return compatibility0
    }
    const lastView =
      per && per.lastView ? new Date(per.lastView).toLocaleDateString() : null

    return (
      <div>
        <div className=" youandocc">
          <h3>{t`You and This college`}</h3>
          <div className="row">
            <div className="useractions col-xs-6">
              <div className="itemrating">
                <button
                  onClick={() => onRateCollege(profile.id, 5)}
                  className="btn"
                  style={{ padding: 0 }}>
                  <img
                    src={rating && rating > 3 ? like : likeInactive}
                    alt={t`Thumbs Up for Like Occupation Link`}
                  />
                </button>
                <button
                  onClick={() => onRateCollege(profile.id, 1)}
                  className="btn"
                  style={{ padding: 0 }}>
                  <img
                    src={rating && rating < 3 ? dislike : dislikeInactive}
                    alt={t`Thumbs down for Dislike Occupation Link`}
                  />
                </button>
                {t`Your Rating`}
              </div>
            </div>
            <div className="useractions col-xs-6">
              <div className="itemcompatability">
                <a href={`/colleges/analysis/${profile.id}`}>
                  <img src={comp()} />
                </a>
                {t`Compatibility`}
              </div>
            </div>
            <div className="col-xs-3 history-item col-xs-offset-3">
              <div className={`personalize-history`}>
                <h4
                  className={
                    ((per && per.educationHistory) || []).length ? 'hasData' : ''
                  }>
                  {((per && per.educationHistory) || []).length || 0}
                </h4>
                <span>{t`Resumes`}</span>
                <button
                  onClick={() =>
                    (window.location = `/jobtools/resume/addeducation?type=college&institutionId=${profile.id}`)}>
                  {t`Add`}
                </button>
              </div>
            </div>
            <div className="col-xs-3 history-item">
              <div className={`personalize-history`}>
                <h4 className={((per && per.journals) || []).length ? 'hasData' : ''}>
                  {((per && per.journals) || []).length || 0}
                </h4>
                <span>{t`Journals`}</span>
                <button onClick={() => onToggleModal('journal', true)}>{t`Add`}</button>
              </div>
            </div>
            <div className="col-xs-3 history-item">
              <div className={`personalize-history`}>
                <h4 className={((per && per.plans) || []).length ? 'hasData' : ''}>
                  {((per && per.plans) || []).length || 0}
                </h4>
                <span>{t`Plans`}</span>
                <button onClick={() => onCreatePlan(profile.id, per.plans)}>
                  {t`Add`}
                </button>
              </div>
            </div>
          </div>
          {per && per.lastView && (
            <div className="lastView">{jt`You last viewed this on ${lastView}`}</div>
          )}
        </div>
      </div>
    )
  }
  const costsAndFees = () => {
    if (!profile.costsFees) {
      return null
    }

    return (
      <div className="section costs-fees-section sections">
        <h3 className="fees">
          <span>{t`Costs and Fees`}</span>
        </h3>
        <ul className="feedetail justified">
          <li className="undergrad-app-fee">
            <span>
              <span>
                <strong>{t`Application Fee:`}</strong>
              </span>{' '}
              <span>
                {' '}
                {profile.costsFees?.undergradApplicationFee?.toLocaleString('en-US', {
                  style: 'currency',
                  minimumFractionDigits: 0,
                  currency: 'USD'
                }) ?? t`n/a`}
              </span>
            </span>
          </li>
          <li className="grad-app-fee">
            <span>
              <span>
                <strong>{t`Graduate Application Fee:`}</strong>
              </span>{' '}
              <span>
                {' '}
                {profile.costsFees?.graduateApplicationFee?.toLocaleString('en-US', {
                  style: 'currency',
                  minimumFractionDigits: 0,
                  currency: 'USD'
                }) ?? t`n/a`}
              </span>
            </span>
          </li>
          <li className="tuituion">
            <span>
              <span>
                <strong>{t`Tuition:`}</strong>
              </span>{' '}
              <span>
                {' '}
                {profile.costsFees?.tuition?.toLocaleString('en-US', {
                  style: 'currency',
                  minimumFractionDigits: 0,
                  currency: 'USD'
                }) ?? t`n/a`}
              </span>
            </span>
          </li>
          <li className="books">
            <span>
              <span>
                <strong>{t`Books & Supplies:`}</strong>
              </span>{' '}
              <span>
                {' '}
                {profile.costsFees?.books?.toLocaleString('en-US', {
                  style: 'currency',
                  minimumFractionDigits: 0,
                  currency: 'USD'
                }) ?? t`n/a`}
              </span>
            </span>
          </li>
          <li className="room-board">
            <span>
              <span>
                <strong>{t`Room & Board:`}</strong>
              </span>{' '}
              <span>
                {' '}
                {profile.costsFees?.roomBoard?.toLocaleString('en-US', {
                  style: 'currency',
                  minimumFractionDigits: 0,
                  currency: 'USD'
                }) ?? t`n/a`}
              </span>
            </span>
          </li>
        </ul>
        <a
          className="btn btn-primary btn-full"
          href={`/colleges/costbenefit/result?institutionId=${profile.id}`}>
          {t`What Will It Cost Me?`}
        </a>
      </div>
    )
  }
  const admissionRequirement = () => {
    const formatDate = date => {
      try {
        const d = new Date(date)
        const day = d.getDate()
        const monthIndex = d.getMonth()

        if (isNaN(monthIndex)) {
          return t`n/a`
        }

        return `${monthNames[monthIndex]} ${day}`
      } catch (e) {
        return t`n/a`
      }
    }

    if (!profile.application) {
      return null
    }

    return (
      <div className="section at-a-glance-section tall sections">
        <h3>
          <span>{t`Application Checklist`}</span>
        </h3>
        <ul id="reqchecklist" className="admission-info justified">
          <li>
            <span>
              <strong>{t`Application Deadline:`}</strong>
            </span>{' '}
            <span className="appdeadline">
              {profile.application.applicationDeadline === 'open'
                ? profile.application.applicationDeadline
                : formatDate(profile.application.applicationDeadline)}
            </span>
          </li>
          {(() => {
            if (profile.application.earlyAction) {
              return (
                <li className="eaction">
                  <span>
                    <strong>{t`Early Action:`}</strong>
                  </span>
                  <span className="data">
                    {formatDate(profile.application.earlyAction.date)}
                    {profile.application.earlyAction.restrictive ? (
                      <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement="bottom"
                        overlay={(
                          <Popover id="earlyActionPopover">
                            {profile.application.earlyAction.description}
                          </Popover>
                        )}>
                        <span className="defined">&#160;{t`(restrictive)`}</span>
                      </OverlayTrigger>
                    ) : null}
                  </span>
                </li>
              )
            }
          })()}
          {(() => {
            if (profile.application.secondEarlyActionDeadline) {
              return (
                <li className="eaction">
                  <span>
                    <strong>{t`Second Early Action:`}</strong>
                  </span>
                  <span className="data">
                    {formatDate(profile.application.secondEarlyActionDeadline.date)}
                  </span>
                </li>
              )
            }
          })()}

          {(() => {
            if (profile.application.earlyDecision) {
              return (
                <li className="eaction">
                  <span>
                    <strong>Early Decision:</strong>
                  </span>
                  <span className="data">
                    {formatDate(profile.application.earlyDecision.date)}
                  </span>
                </li>
              )
            }
          })()}
          <li>
            <span>
              <strong>{t`Common Application:`}</strong>
            </span>{' '}
            <span className="commonapp">
              {profile.application?.commonApplication ? t`yes` : t`no`}
            </span>
          </li>
          <li>
            <span>
              <strong>{t`Universal Application:`}</strong>
            </span>{' '}
            <span className="universalapp">
              {profile.application?.universalApplication ? t`yes` : t`no`}
            </span>
          </li>

          <li>
            <span>
              <strong>{t`Admissions Tests: `}</strong>
            </span>{' '}
            <span className="required">
              {profile.quickFacts?.admissionsTestsRequired}
            </span>
          </li>
          <li>
            <span>
              <strong>{t`Teacher Recommendations: `}</strong>
            </span>{' '}
            <span className="recommend">
              {profile.quickFacts?.recommendationsRequired}
            </span>
          </li>
          <li>
            <span>
              <strong>{t`School GPA: `}</strong>
            </span>{' '}
            <span className="gpa">{profile.quickFacts?.secondarySchoolGpa}</span>
          </li>
          <li>
            <span>
              <strong>{t`Class Rank:`}</strong>
            </span>{' '}
            <span className="rank">{profile.quickFacts?.secondarySchoolRank}</span>
          </li>
          <li>
            <span>
              <strong>{t`Transcript:`}</strong>
            </span>{' '}
            <span className="record">{profile.quickFacts?.secondarySchoolRecord}</span>
          </li>
        </ul>
      </div>
    )
  }

  useTitleChange(null)
  useInitDispatch(loadCollege(match?.params?.collegeId), [match?.params?.collegeId])
  useEffect(() => {
    if (selected) {
      setProfile(selected)
    }
  }, [selected, setProfile])

  if (!profile) {
    return <LoadingIndicator newSiteLook={dynamicValues.newSiteLook} />
  }

  return (
    <div id="profileinfocontainer">
      <div className="container">
        <div className="">
          <div className="headerBox row institution">
            <div className="title-section col-sm-5">
              <h3>{profile.name}</h3>
            </div>
            <div className="lmi-callout col-sm-5">
              <div className="row">
                <div className="col-sm-6">
                  <h4>{t`Annual Tuition `}</h4>
                  <h5>
                    {(profile.costsFees &&
                      profile.costsFees.tuition?.toLocaleString('en-US', {
                        style: 'currency',
                        minimumFractionDigits: 0,
                        currency: 'USD'
                      })) ||
                      t`n/a`}
                  </h5>
                </div>
                <div className="col-sm-6">
                  <h4>{t`Annual Room & Board`}</h4>
                  <h5>
                    {(profile.costsFees &&
                      profile.costsFees.roomBoard?.toLocaleString('en-US', {
                        style: 'currency',
                        minimumFractionDigits: 0,
                        currency: 'USD'
                      })) ||
                      t`n/a`}
                  </h5>
                </div>
                <div className="col-sm-6">
                  {(() => {
                    const studentBodySize =
                      profile &&
                      profile.enrollments &&
                      profile.enrollments.values &&
                      profile.enrollments.values.find(
                        e => e.degreeType && e.degreeType === 'Total'
                      )

                    return (
                      <div key="studentBodySection">
                        <h4>{t`Student Body Size`}</h4>
                        <h5>
                          {(studentBodySize &&
                            studentBodySize.attendenceStatus &&
                            studentBodySize.attendenceStatus.total.toLocaleString()) ||
                            t`n/a`}
                        </h5>
                      </div>
                    )
                  })()}
                </div>
                <div className="col-sm-6">
                  {(() => {
                    const rate = profile.admissions && profile.admissions.totalAcceptance

                    return (
                      <div key="acceptanceRateSection">
                        <h4>{t`Acceptance Rate`}</h4>
                        <h5>{(rate && `${rate}%`) || t`n/a`}</h5>
                      </div>
                    )
                  })()}
                </div>
              </div>
            </div>
            <div className="col-sm-2 action-container">
              <button className="btn no-style media">
                <div className="thumb no-opacity">
                  <ReactImageFallback
                    style={{ zIndex: '1' }}
                    src={collegeImageUrl}
                    fallbackImage={fallbackCollegeImage}
                  />
                </div>
                {profile?.domain && (
                  <div
                    style={{
                      position: 'absolute',
                      right: 0,
                      zIndex: 5,
                      bottom: 0
                    }}>
                    <a
                      href="https://clearbit.com"
                      style={{
                        backgroundColor: 'rgba(0,0,0,.4)',
                        fontSize: '12px',
                        color: 'white',
                        display: 'inline-block'
                      }}>
                      {t`Logo provided by Clearbit`}
                    </a>
                  </div>
                )}
              </button>
              <button className="btn share" onClick={() => onToggleModal('share')}>
                <span className="sr-only">{t`Share`}</span>
              </button>
              <a className="btn print" href={profile.printUrl}>
                <span className="sr-only">{t`Print`}</span>
              </a>
              {/*<a className="btn" href="javascript:void(0)" onClick={() => onFlagCollege(profile.id)}>
                                <i className="fal fa-flag" style={{ color: (profile.personalization && profile.personalization.hasOwnProperty('bookmarked') && profile.personalization.bookmarked) ? "orange" : "initial" }}></i><span className="sr-only">{t`Bookmark`}</span>
                            </a>*/}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8 leftcolprofile">
            {aboutSection()}
            <AdmissionSection admissions={profile.admissions} />
            <EnrollmentSection enrollments={profile.enrollments} />
            <TuitionSection tuition={profile.tuition} />
            <FinancialAidSection aid={profile.financialAid} />
          </div>
          <div className="col-sm-4 rightcol">
            {youAndOcc()}

            {admissionRequirement()}

            {costsAndFees()}

            <StudentBodySection demographics={profile.demographics} />
            <MajorListing majors={profile.majors || []} />
          </div>
        </div>
      </div>
      <Modal
        bsSize="large"
        enforceFocus={false}
        show={modals && modals.selectedModal === 'journal'}
        onHide={() => onToggleModal(null)}>
        <Modal.Header closeButton>
          <h2>{t`Journal Entries`}</h2>
        </Modal.Header>
        <Modal.Body>
          {profile.personalization && profile.personalization.journals && (
            <PopupJournal
              journals={profile.personalization.journals}
              objectType={profile.personalization.journalType}
              objectId={profile.id}
              objectTitle={profile.name}
            />
          )}
        </Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        show={modals && modals.selectedModal === 'share'}
        onHide={() => onToggleModal(null)}>
        <Modal.Header closeButton>
          <h2>{t`Social`}</h2>
        </Modal.Header>
        <Modal.Body>
          <Share />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default connect(
  state => {
    return {
      ...state.college.profile,
      modals: state.modals.college
    }
  },
  dispatch => ({
    onRateCollege: (instituionId, rating) => {
      if (dynamicValues.userProfile) {
        dispatch(rateCollege(instituionId, rating))
      } else {
        dispatch(openSigninDialog('signIn'))
      }
    },
    onCreatePlan: (institutionId, plans) => {
      if (plans.length > 0) {
        window.location.href = plans[0].url
      } else {
        dispatch(createPlan(institutionId)).then(p => {
          window.location.href = p.url
        })
      }
    },
    onToggleModal: (modalName, requireLoggedIn) => {
      if (!!requireLoggedIn && !dynamicValues.userProfile) {
        dispatch(openSigninDialog('signIn'))
      } else {
        dispatch(toggleModal('college')(modalName))
      }
    },
    onFlagCollege: institutionId => {
      dispatch(toggleCollegeFlag(institutionId))
    },
    dispatch
  })
)(CollegeProfile)
